import React, { useEffect, useRef, useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import image from '../../assets/image.png';
import sendFormData from "../../Data/formData.js";
import senddata from "../../Data/data.js";
import { json } from 'react-router-dom';


function QuestionBank() {

  const fileInputRef = useRef(null);

  const [openAddQ,setOpenAddQ]=useState(false);
  const [showQ,setShowQ]=useState(false);
  const [loading,setLoading]=useState(false);
  const [refresh,setRefresh]=useState(false);

  const [question,setQuestion]=useState("");
  const [role,setRole]=useState("choice");
  const [mark,setMark]=useState("");
  const [answer1,setAnswer1]=useState("");
  const [answer2,setAnswer2]=useState("");
  const [answer3,setAnswer3]=useState("");
  const [answer4,setAnswer4]=useState("");
  const [lec,setLec]=useState("");
  const [year,setYear]=useState("one");
  const [correctChoice,setCorrectChoice]=useState("answer_1");
  const [correctBoolean,setCorrectBoolean]=useState("answer_1");
  const [correctcomplete,setCorrectcomplete]=useState([""]);
  // const [dialoguecompletionSpaces,setDialoguecompletionSpaces]=useState([[]]);
  const [file,setFile]=useState("");

  const [dialogueAnswers,setDialogueAnswers]=useState([""]);

  const [selectedImage,setSelectedImage]=useState("");


  const [allQuestions,setAllQuestions]=useState([]);
  const [filteredQuestions,setFilteredQuestions]=useState([]);
  const [searchText,setSearchText]=useState("");
  const [searchLevel,setSearchLevel]=useState("one");
  const [searchLec,setSearchLec]=useState("");
  const [lecOptions,setLecOptions]=useState([""]);

  // 25/7
  // edit
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(()=>{
    if(showQ){
      setLoading(true);
      getAllQuestions();
      setOpenAddQ(false);
    }
  },[showQ])

  useEffect(()=>{
    if(showQ){
      getAllQuestions();
    }
  },[refresh])

  useEffect(()=>{
    if(openAddQ){
      setShowQ(false)
    }
  },[openAddQ])

  useEffect(()=>{
    console.log("filteredData1")
    filterQuestions();
  },[searchText,searchLevel,searchLec,allQuestions])



  const getAllQuestions =() =>{
    senddata("questionbank/get_questions",{}, "GET").then((res) => {
      if (res.status !== 200) {
      alert('تأكد من الاتصال من الانترنت ');
      } else {
        setAllQuestions(res.data);
        setLoading(false);
      }
      });
  }

  const filterQuestions =()=>{
    if(searchText){
      const filteredData = allQuestions.filter((question)=> (question.year==searchLevel&& ((question.lec+question.question+question.answer_1+question.answer_2+question.answer_3+question.answer_4).toLowerCase().includes(searchText.toLowerCase()) )) );
      setFilteredQuestions(filteredData);
    }else{
      const filteredData = allQuestions.filter((question)=> ( question.year==searchLevel ) );
      setFilteredQuestions(filteredData);
    }
  }


  const addQuestion = ()=>{
    const dialoguecompletionSpaces = dialogueAnswers.map(answer => answer.split("+"));
    console.log(dialoguecompletionSpaces)
    let data = new FormData();
    data.append('question', question);
    data.append('role', role);
    data.append('mark', mark);
    data.append('answer_1', answer1);
    data.append('answer_2', answer2);
    data.append('answer_3', answer3);
    data.append('answer_4', answer4);
    data.append('lec', lec);
    data.append('year', year);
    data.append('correctChoice', correctChoice);
    data.append('correctBoolean', correctBoolean);
    data.append('dialoguecompletionSpaces',JSON.stringify(dialoguecompletionSpaces) );
    data.append('correctcomplete', JSON.stringify(correctcomplete));
    data.append('file',file );

    sendFormData("questionbank/add_question", data, "POST").then((res) => {
      if (res?.status !== 200) {
        alert(` تأكد من الاتصال بالانترنت`);
      } else {
        alert("تم اضافة السؤال   ");
        setQuestion("");
        setFile("");
        setSelectedImage("");
      }
    });
  }

  // 25/7
  const updateQuestion = () => {
    const dialoguecompletionSpaces = dialogueAnswers.map(answer => answer.split("+"));

    let data = new FormData();
    data.append('question', question);
    data.append('role', role);
    data.append('mark', mark);
    data.append('answer_1', answer1);
    data.append('answer_2', answer2);
    data.append('answer_3', answer3);
    data.append('answer_4', answer4);
    data.append('lec', lec);
    data.append('year', year);
    data.append('correctChoice', correctChoice);
    data.append('correctBoolean', correctBoolean);
    data.append('dialoguecompletionSpaces', JSON.stringify(dialoguecompletionSpaces));
    data.append('correctcomplete', JSON.stringify(correctcomplete));
    data.append('file', file);

    sendFormData(`questionbank/edit_question/${editId}`, data, "PUT").then((res) => {
      if (res?.status !== 200) {
        alert(`تأكد من الاتصال بالانترنت`);
      } else {
        alert("✅ تم تحديث السؤال بنجاح");
        setQuestion("");
        setFile("");
        setSelectedImage("");
      }
    });
  };

  const handleFileChange = (e) => {
    const newfile = e.target.files[0];
    if (newfile) {
        const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
        if (!validImageTypes.includes(newfile.type)) {
          alert("ادخل صورة ")
          return;
      }
        setFile(newfile)
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result); 
        };
        reader.readAsDataURL(newfile); 
    }else {
      setSelectedImage(""); 
      setFile("");
    }
  };

  const deleteQuestion = (id)=>{
      // confirm
      const userResponse = prompt(`امتب Ok لتأكيد حذف السؤال `);
      // delete
      if(userResponse?.trim() =="ok" ){
        senddata(`questionbank/delete_question/${id}`,{}, "DELETE").then((res) => {
          if (res.status !== 200) {
            alert('تأكد من الاتصال بالانترنت');
          } else {
            alert('تم حذف السؤال  ');
            setRefresh(!refresh);
          }
          });
      }else{
        alert("لم يتم حذف الطالب")
      }
  }

  // 25/7
  const clearForm = () => {
    setQuestion("");
    setRole("choice");
    setMark("");
    setAnswer1("");
    setAnswer2("");
    setAnswer3("");
    setAnswer4("");
    setLec("");
    setYear("one");
    setCorrectChoice("answer_1");
    setCorrectBoolean("answer_1");
    setCorrectcomplete([""]);
    setDialogueAnswers([""]);
    setFile("");
    setSelectedImage("");
    setEditMode(false);
    setEditId(null);
  };

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
      <div className='headers  '>
          <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      {/* add */}
      <div className='add_student p-5 w-screen xl:w-[80%] xl:ml-[10%] text-right flex flex-col justify-end '>
          <p onClick={()=>{setOpenAddQ(!openAddQ)}} className='px-10 py-2 mb-4 bg-[#e9ad03] w-fit rounded-full cursor-pointer'>{openAddQ?"اخفاء الاضافة":"اضافة سؤال"}</p> 
          {openAddQ&&
          <div>
            <div className=' grid grid-cols-1 rever gap-4'>
              <img src={selectedImage} className='w-full mb-4 lg:w-[60%] lg:ml-[20%]' />
            </div>
            <div className=' grid grid-cols-1 rever gap-4'>
              <textarea 
                type="text"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder={role=="correct"?'example : I .......(just know) about the compitation .':'السؤال'}
                />
            </div>
            <div className=' grid grid-cols-2 rever gap-4'>
              <select value={role} onChange={(event)=>{setRole(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                <option value="choice" className=' text-black'>اختياري</option>
                {/* <option value="boolean" className=' text-black'>صح و خطأ</option> */}
                <option value="correct" className=' text-black'>correct</option>
                <option value="text" className=' text-black'>قطعة</option>
                <option value="dialogue" className=' text-black'>dialogue</option>
                <option value="complete" className=' text-black'>copmlete</option>
              </select>

              <input 
                type="number"
                value={mark}
                onChange={(e) => setMark(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='الدرجة'
                />
          </div>
          {role=="choice"&&<div className=' grid grid-cols-2 rever gap-4'>
              <input 
                type="text"
                value={answer2}
                onChange={(e) => setAnswer2(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder='الاختيار الثاني'
                />
              <input 
                type="text"
                value={answer1}
                onChange={(e) => setAnswer1(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder='الاختيار الأول'
                />
          </div>}
          {role=="choice"&&<div className=' grid grid-cols-2 rever gap-4'>
              <input 
                type="text"
                value={answer4}
                onChange={(e) => setAnswer4(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder='الاختيار الرابع'
                />
              <input 
                type="text"
                value={answer3}
                onChange={(e) => setAnswer3(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder='الاختيار الثالث'
                />
          </div>}
          {role=="choice"&&<div className=' grid grid-cols-2 rever gap-4'>
              <p></p>
              <select value={correctChoice} onChange={(event)=>{setCorrectChoice(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right text-green-400 " >
                <option value="answer_1" className='text-black' >{answer1}</option>
                <option value="answer_2" className='text-black' >{answer2}</option>
                <option value="answer_3" className='text-black' >{answer3}</option>
                <option value="answer_4" className='text-black' >{answer4}</option>
              </select>
          </div>}
          {role=="boolean"&&<div className=' grid grid-cols-2 rever gap-4'>
              <p></p>
              <select value={correctBoolean} onChange={(event)=>{setCorrectBoolean(event.target.value);}} className={"bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right " +( correctBoolean=="answer_1"?"text-green-400":"text-red-400")}>
                <option value="answer_1" className=' text-green-600'>الاجابة صحيحة</option>
                <option value="answer_2" className=' text-red-600'>الاجابة خاطئة</option>
              </select>
          </div>}

          {/* correct */}

          {role=="correct"&&<div className=' grid grid-cols-2 rever gap-4'>
            <p></p>
            <input 
                type="text"
                value={answer1}
                onChange={(e) => setAnswer1(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder=' الاجابة الصحيحة'
                />
          </div>}

          {/* text */}

          {role=="text"&&<div className=' grid grid-cols-1 rever gap-4'>
            <label 
                className="bg-transparent p-2 text-right ">
                  يرجي اضافة صورة للقطعة و يتم مقارنة مدي قرب اجابة الطالب للاجابات الصحيحة 
            </label>
            <input 
                type="text"
                value={answer1}
                onChange={(e) => setAnswer1(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder=' اجابة محتملة 1 '
                />
            <input 
                type="text"
                value={answer2}
                onChange={(e) => setAnswer2(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder=' اجابة محتملة 2'
                />
            <input 
                type="text"
                value={answer3}
                onChange={(e) => setAnswer3(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder=' اجابة محتملة 3'
                />
            <input 
                type="text"
                value={answer4}
                onChange={(e) => setAnswer4(e.target.value)}
                className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right "
                placeholder='اجابة محتملة 4'
                />
          </div>}

          {/* dialogue */}

          {role=="dialogue"&&<div className=' grid grid-cols-1 rever gap-4'>
            <label 
                className="bg-transparent p-2 text-right ">
                  يرجي اضافة صورة للمحادثة والاجابات المحتملة بالترتيب  , يرجي الفصل بين الاجابات المحتملة بعلامة +
            </label>
            {dialogueAnswers.map((item,key)=>{
              return(
                <div className='flex flex-row items-center'>
                  {dialogueAnswers.length==(key+1)&&<p onClick={()=>{setDialogueAnswers(prevAnswers => [...prevAnswers, ""]);}} className=' cursor-pointer border-2 border-[#e9ad03]  rounded-full mr-4 '>➕</p>}
                  {dialogueAnswers.length!=1 && <p onClick={()=>{
                    setDialogueAnswers(prevAnswers => 
                      prevAnswers.filter((_, i) => i != key)
                    );
                  }} 
                    className=' cursor-pointer border-2 border-[#e9ad03]  rounded-full mr-4 '>➖</p>}
                  <input 
                    type="text"
                    value={dialogueAnswers[key]}
                    onChange={(e) =>{
                        setDialogueAnswers(prevAnswers => 
                        prevAnswers.map((answer, i) => (i == key ? e.target.value : answer))
                      );
                    }}
                    className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right flex-1 "
                    placeholder={` اجابة ${key+1}  `}
                  />
                </div>
              )
            })
            }

          </div>}

          {/* complete */}

          {role=="complete"&&<div className=' grid grid-cols-1 rever gap-4'>
            <label 
                className="bg-transparent p-2 text-right ">
                  يرجي اضافة صورة للقطعة بالمسافات و ادخال الاجابات بالترتيب
            </label>
            {correctcomplete.map((item,key)=>{
              return(
                <div className='flex flex-row items-center'>
                  {correctcomplete.length==(key+1)&&<p onClick={()=>{setCorrectcomplete(prevAnswers => [...prevAnswers, ""]);}} className=' cursor-pointer border-2 border-[#e9ad03]  rounded-full mr-4 '>➕</p>}
                  {correctcomplete.length!=1 && <p onClick={()=>{
                    setCorrectcomplete(prevAnswers => 
                      prevAnswers.filter((_, i) => i != key)
                    );
                  }} 
                    className=' cursor-pointer border-2 border-[#e9ad03]  rounded-full mr-4 '>➖</p>}
                  <input 
                    type="text"
                    value={correctcomplete[key]}
                    onChange={(e) =>{
                        setCorrectcomplete(prevAnswers => 
                        prevAnswers.map((answer, i) => (i == key ? e.target.value : answer))
                      );
                    }}
                    className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none p-2 text-right flex-1 "
                    placeholder={` اجابة ${key+1}  `}
                  />
                </div>
              )
            })
            }

          </div>}

          {/* general inputs */}
          <div className=' grid grid-cols-2 rever gap-4'>
              <select value={year} onChange={(event)=>{setYear(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                <option value="six-pri" className=' text-black'>ستة ابتدائي</option>
                <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
              </select>
              <input 
                type="text"
                value={lec}
                onChange={(e) => setLec(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='المحاضرة'
                />
          </div>
            <div className=' grid grid-cols-2 rever gap-4'>
              {/* 25/7 */}
              <p
                onClick={() => {
                  if (editMode) {
                    updateQuestion();
                  } else {
                    addQuestion();
                  }
                }}
                className='px-6 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6'
              >
                {editMode ? "تحديث السؤال" : "اضافة سؤال"}
              </p>
              {editMode && (
                <p
                  onClick={clearForm}
                  className='px-6 py-2 bg-gray-500 text-white w-fit rounded-full cursor-pointer mt-2'
                >
                  إلغاء التعديل
                </p>
              )}
              <div className='h-full flex items-end justify-end' >
                <p onClick={()=>{setFile("");setSelectedImage("");}} className='mr-4 text-2xl cursor-pointer'>🗑️</p>
                <img src={image} className='w-12 rounded-full mt-auto lg:mr-5 cursor-pointer' onClick={()=>{fileInputRef.current.click()}} />
              </div>
              <input 
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                />
            </div>
          </div>
          }
      </div>
      {/* display */}
      <div className='add_student p-5 w-screen text-right flex flex-col justify-end mt-[80px] '>
        <div className='flex flex-row justify-between'>
          <p onClick={()=>{setShowQ(!showQ)}} className='px-10 py-2 mb-4 bg-[#eb0000] w-fit rounded-full cursor-pointer'>{showQ?"اخفاء بنك الأسئلة":"اظهار بنك الأسئلة"}</p> 
          {showQ&&<p >{filteredQuestions.length} : عدد الأسئلة</p>}
        </div>
          {loading&&showQ&&<p>loading</p>}
          {
            showQ&&<div className='flex flex-row items-center justify-between pl-4 mb-10'>
             <input value={searchText} onChange={(e)=>{setSearchText(e.target.value)}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right" placeholder='البحث'/>
             <select value={searchLevel} onChange={(event)=>{setSearchLevel(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                <option value="six-pri" className=' text-black'>ستة ابتدائي</option>
                <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
             </select>
           </div>
          }
          {showQ&&filteredQuestions.length&&
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[90%] ml-[5%] '>
            {
              filteredQuestions?.map((question,key)=>{
                return(
                  <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                    {question.img!="empty" && <div className=' grid grid-cols-1 rever gap-4'>
                      <img src={question.img} className='w-full mb-4 ' />
                    </div>}
                    <div className='p-3'>
                        <p className=' text-center text-[#e9ad03]'>{"السؤال"+" " +key} </p>
                        <p dir='rtl' > 👈 {question.question}</p>
                        {/* choice */}
                        {question.role=="choice"&&<p className=' text-center text-[#e9ad03]'>الاختيارات</p>}
                        {question.role=="choice"&&<>
                        <p className='mr-4' dir='rtl' >1- {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' >2- {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' >3- {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' >4- {question.answer_4}</p>
                        </>}
                        {/* correct */}
                        {question.role=="correct"&&<p className=' text-center text-[#e9ad03]'>الاجابة صحيحة</p>}
                        {question.role=="correct"&&<>
                        <p className='mr-4' dir='rtl' >{question.answer_1}</p>
                        </>}
                        {/* text */}
                        {question.role=="text"&&<p className=' text-center text-[#e9ad03]'>الاجابات المحتملة للقطعة</p>}
                        {question.role=="text"&&<>
                        <p className='mr-4' dir='rtl' > {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_4}</p>
                        </>}
                        {/* dialogue */}
                        {question.role=="dialogue"&&<p className=' text-center text-[#e9ad03]'>تكملة المحادثة</p>}
                        {
                          question.role=="dialogue" && question?.dialoguecompletionSpaces.length && question?.dialoguecompletionSpaces?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : </p>
                              <>
                                {item.length&&item?.map((answer)=>{
                                   return(<p className='mr-4' dir='rtl' > {answer} </p>)
                                })}
                              </>
                            </>
                          )
                          })
                        }
                        {/* complete */}
                        {question.role=="complete"&&<p className=' text-center text-[#e9ad03]'>التكملة الصحيحة</p>}
                        {
                          question.role=="complete" && question?.correctcomplete.length && question?.correctcomplete?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : {item} </p>
                            </>
                          )
                          })
                        }


                      <div className=' grid grid-cols-3 rever gap-4'>
                        {/* choice */}
                        {question.role=="choice"&&<p>{question.correctChoice=="answer_1"? "A":question.correctChoice=="answer_2"?"B":question.correctChoice=="answer_3"?"C":question.correctChoice=="answer_4"?"d":""} الاجابة</p>}
                        {/* bolean */}
                        {question.role=="boolean"&&<p>{question.correctBoolean=="answer_1"?"الاجابة صحيحة":"الاجابة خاطئة"}</p>}
                        <p>{question.mark} : الدرجة</p>
                        <div>
                          <span>
                            ❌{question.wrongAnswerCount}
                          </span>
                          |
                          <span> 
                            ✅{question.correctAnswerCount}
                          </span>  
                        </div>
                      </div>

                          
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                          <p onClick={()=>{deleteQuestion(question._id)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                          {/* 25/7 */}
                          <p
                            className='mr-4 text-lg cursor-pointer'
                            onClick={() => {
                              setEditMode(true);
                              setOpenAddQ(true);
                              setShowQ(false);

                              // ملء الحقول
                              setEditId(question._id);
                              setQuestion(question.question);
                              setRole(question.role);
                              setMark(question.mark);
                              setAnswer1(question.answer_1 || "");
                              setAnswer2(question.answer_2 || "");
                              setAnswer3(question.answer_3 || "");
                              setAnswer4(question.answer_4 || "");
                              setLec(question.lec);
                              setYear(question.year);
                              setCorrectChoice(question.correctChoice || "answer_1");
                              setCorrectBoolean(question.correctBoolean || "answer_1");
                              setCorrectcomplete(question.correctcomplete || [""]);
                              setDialogueAnswers(question.dialoguecompletionSpaces?.map(item => item.join("+")) || [""]);
                              setSelectedImage(question.img !== "empty" ? question.img : "");
                            }}
                          >✏️</p>
                        </div>
                        <p>{question.lec} : التصنيف </p>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
          }
      </div>
      
    </div>
  )
}

export default QuestionBank
